(function () {
  'use strict';

  var Utils = window.TDCUtils;
  var page = document.querySelector('.pdp-page');
  if (!page) return;

  var productForm = document.getElementById('product-form') || document.querySelector('form[action$="/cart/add"]');
  var quantityInput = document.getElementById('quantity');
  var qtyOutput = document.getElementById('qty');
  var addToCartBtn = document.getElementById('add-btn');
  var addTotal = document.getElementById('add-total');
  var variantIdInput = document.getElementById('variant-id');
  var priceEl = document.getElementById('p-price');
  var skuEl = document.getElementById('p-sku');
  var skuValue = document.getElementById('p-sku-value');
  var stockEl = document.getElementById('stock');
  var stockText = document.getElementById('stock-text');
  var buyRow = document.getElementById('buy-row');
  var buyExtra = document.getElementById('buy-extra');
  var notify = document.getElementById('notify-me-app-hook');
  var stageImg = document.getElementById('stage-img');
  var stageBtn = document.getElementById('stage-btn');
  var thumbs = document.getElementById('thumbs');
  var stageCount = document.getElementById('stage-count');
  var lbImg = document.getElementById('lb-img');
  var lbCount = document.getElementById('lb-count');
  var lightbox = document.getElementById('lightbox');
  var sticky = document.getElementById('sticky-buy');
  var stickyAdd = document.getElementById('sticky-add');
  var stickyTitle = document.getElementById('sticky-title');
  var stickyPrice = document.getElementById('sticky-price');
  var stickyImg = document.getElementById('sticky-img');

  var productJson = null;
  var media = [];
  var idx = 0;
  var selectedOptions = [];
  var variantSectionRequest = 0;

  // Stock verification variables
  var stockCheckPassed = false;
  var stockCheckPending = false;

  // Cache for media collection to avoid repeated DOM queries
  var mediaCache = null;
  var mediaCacheDirty = true;

  var productInvMap = {};
  try {
    var invScript = document.getElementById('product-variants-inv-json');
    if (invScript) {
      productInvMap = JSON.parse(invScript.textContent) || {};
      window._variantInventory = window._variantInventory || {};
      Object.assign(window._variantInventory, productInvMap);
    }
  } catch (e) {}

  function getCartQtyForVariant(variantId) {
    if (!variantId) return 0;
    var cart = (window.TDCCart && window.TDCCart.currentCart) || window._themeCart || null;
    if (cart && cart.items) {
      var item = cart.items.find(function (i) {
        return String(i.id) === String(variantId) || String(i.variant_id) === String(variantId);
      });
      if (item) return parseInt(item.quantity, 10) || 0;
    }
    return 0;
  }

  try {
    var productJsonEl = document.getElementById('product-json');
    if (productJsonEl) productJson = JSON.parse(productJsonEl.textContent);
    if (productJson && productJson.variants) {
      window._variantComparePrices = window._variantComparePrices || {};
      productJson.variants.forEach(function (v) {
        if (v.compare_at_price && v.compare_at_price > v.price) {
          window._variantComparePrices[v.id] = v.compare_at_price;
        }
      });
    }
  } catch (e) {}

  try {
    var mediaScript = document.getElementById('product-media-json');
    if (mediaScript) media = JSON.parse(mediaScript.textContent) || [];
  } catch (e) {}

  if (productJson && productJson.options) {
    selectedOptions = (productJson.variants && productJson.variants.length)
      ? productJson.variants.find(function (v) { return String(v.id) === String(variantIdInput && variantIdInput.value); }) || productJson.variants[0]
      : null;
    if (selectedOptions) {
      selectedOptions = [selectedOptions.option1, selectedOptions.option2, selectedOptions.option3].filter(Boolean);
    } else {
      selectedOptions = [];
    }
  }

  function money(cents) {
    if (Utils && Utils.formatMoney) return Utils.formatMoney(cents);
    return '$' + (cents / 100).toFixed(0);
  }

  function currentVariant() {
    if (!productJson || !productJson.variants) return null;
    return productJson.variants.find(function (v) {
      return selectedOptions.every(function (opt, i) {
        return !opt || v['option' + (i + 1)] === opt;
      });
    }) || productJson.variants[0];
  }

  // Cache for media collection to avoid repeated DOM queries
  var mediaCache = null;

  function collectMedia() {
    // Return cached media if available
    if (mediaCache) {
      return mediaCache;
    }

    var list = [];
    if (thumbs) {
      thumbs.querySelectorAll('.thumb-btn').forEach(function (btn) {
        var img = btn.querySelector('img');
        if (!img) return;
        list.push({
          id: btn.getAttribute('data-media-id'),
          src: btn.getAttribute('data-full-src') || img.currentSrc || img.src,
          alt: img.alt || '',
          product: btn.getAttribute('data-packshot') === 'true'
        });
      });
    }

    // Cache the media list
    mediaCache = list;
    return mediaCache;
  }

  function setGalleryImage(img, src, alt) {
    if (!img || !src) return;
    img.removeAttribute('srcset');
    img.removeAttribute('sizes');
    img.loading = 'eager';
    img.alt = alt || '';
    img.src = src;
  }

  function preloadGallery(src) {
    if (!src) return;
    var preloadImg = new Image();
    preloadImg.src = src;
  }

  // Preload all images on init using cached media
  if (mediaCache) {
    mediaCache.forEach(function (item) {
      preloadGallery(item.src);
    });
  } else {
    // Fallback if cache not yet populated
    collectMedia().forEach(function (item) {
      preloadGallery(item.src);
    });
  }

  function showMedia(i) {
    var list = collectMedia();
    if (!list.length) return;
    idx = (i + list.length) % list.length;
    var item = list[idx];
    setGalleryImage(stageImg, item.src, item.alt);
    setGalleryImage(lbImg, item.src, item.alt);
    if (stageBtn) stageBtn.classList.toggle('product', !!item.product);
    if (stageCount) stageCount.textContent = (idx + 1) + ' / ' + list.length;
    if (thumbs) {
      thumbs.querySelectorAll('.thumb-btn').forEach(function (b, n) {
        b.setAttribute('aria-current', n === idx ? 'true' : 'false');
        if (n === idx) {
          var thumbViewport = b.closest('.thumbs');
          if (thumbViewport) {
            var isHorizontal = window.matchMedia('(max-width: 1080px)').matches;
            var start = isHorizontal ? b.offsetLeft : b.offsetTop;
            var end = start + (isHorizontal ? b.offsetWidth : b.offsetHeight);
            var viewportStart = isHorizontal ? thumbViewport.scrollLeft : thumbViewport.scrollTop;
            var viewportEnd = viewportStart + (isHorizontal ? thumbViewport.clientWidth : thumbViewport.clientHeight);
            if (start < viewportStart) {
              thumbViewport.scrollTo(isHorizontal
                ? { left: start, behavior: 'smooth' }
                : { top: start, behavior: 'smooth' });
            } else if (end > viewportEnd) {
              var target = end - (isHorizontal ? thumbViewport.clientWidth : thumbViewport.clientHeight);
              thumbViewport.scrollTo(isHorizontal
                ? { left: target, behavior: 'smooth' }
                : { top: target, behavior: 'smooth' });
            }
          }
        }
      });
    }
    if (lbCount) lbCount.textContent = (idx + 1) + ' / ' + list.length;
    if (stickyImg && item.src) stickyImg.src = item.src;
    var next = list[(idx + 1) % list.length];
    var prev = list[(idx - 1 + list.length) % list.length];
    if (next) preloadGallery(next.src);
    if (prev && prev !== next) preloadGallery(prev.src);
  }

  var initialMediaId = page.querySelector('.gallery[data-initial-media-id]');
  if (initialMediaId) {
    var initialIndex = collectMedia().findIndex(function (item) {
      return String(item.id) === initialMediaId.getAttribute('data-initial-media-id');
    });
    if (initialIndex >= 0) showMedia(initialIndex);
  }

  function getInvLimit(forVariantId) {
    var variant = currentVariant();
    var variantId = forVariantId || (variant ? variant.id : (variantIdInput ? variantIdInput.value : null));
    // productInvMap / _variantInventory has live data from Section Rendering API (most accurate)
    var invData = (variantId && productInvMap[variantId]) ||
                  (variantId && window._variantInventory && window._variantInventory[variantId]) || null;
    var qInput = document.getElementById('quantity') || quantityInput;

    var managed, policy, qty;
    if (invData) {
      // Freshest source: live Section Rendering API data
      managed = invData.management;
      policy  = invData.policy;
      qty     = invData.qty != null ? parseInt(invData.qty, 10) : NaN;
    }
    
    // Always check productJson variants if qty is still NaN or invData not present
    if ((isNaN(qty) || managed == null) && variantId && productJson && productJson.variants) {
      var pjVariant = productJson.variants.find(function(v){ return String(v.id) === String(variantId); });
      if (pjVariant) {
        managed = pjVariant.inventory_management || managed || '';
        policy  = pjVariant.inventory_policy || policy || '';
        if (pjVariant.inventory_quantity != null) {
          qty = parseInt(pjVariant.inventory_quantity, 10);
        }
      }
    }

    if (!managed && !policy) {
      // Fallback: Liquid-rendered data attributes on the hidden quantity input (only if same variant).
      var domVariantId = qInput && qInput.getAttribute('data-variant-id');
      if (!forVariantId || !domVariantId || String(domVariantId) === String(variantId)) {
        managed = qInput && qInput.getAttribute('data-inv-managed');
        policy  = qInput && qInput.getAttribute('data-inv-policy');
        var rawQty = parseInt(qInput && qInput.getAttribute('data-inv-qty'), 10);
        if (isNaN(qty)) qty = !isNaN(rawQty) ? rawQty : NaN;
      }
    }

    policy = policy || (variant && !forVariantId && variant.inventory_policy) || '';

    // If Shopify setting is "Continue selling when out of stock" ON, oversell is allowed: NO quantity cap!
    if (policy === 'continue') return 99;

    // Ultra-reliable fallback: check visible stock badge ('Only X left, ready to ship')
    // ONLY use this when not switching variants (forVariantId not given) to avoid stale DOM reads
    if (!forVariantId) {
      var stockTextEl = document.getElementById('stock-text');
      if (stockTextEl) {
        var match = stockTextEl.textContent.match(/Only\s+(\d+)\s+left/i);
        if (match) {
          var textQty = parseInt(match[1], 10);
          if (!isNaN(textQty)) {
            managed = managed || 'shopify';
            if (!policy || policy === '') policy = 'deny';
            qty = textQty;
          }
        }
      }
    }

    if (managed && managed !== '' && policy !== 'continue' && !isNaN(qty)) return Math.max(0, qty);
    return 99;
  }

  function hasInventoryLimit(forVariantId) {
    var variant = currentVariant();
    var variantId = forVariantId || (variant ? variant.id : (variantIdInput ? variantIdInput.value : null));
    var invData = (variantId && productInvMap[variantId]) ||
                  (variantId && window._variantInventory && window._variantInventory[variantId]) || null;
    var qInput = document.getElementById('quantity') || quantityInput;

    var managed, policy, qty;
    if (invData) {
      managed = invData.management;
      policy  = invData.policy;
      qty     = invData.qty != null ? parseInt(invData.qty, 10) : NaN;
    }

    if ((isNaN(qty) || managed == null) && variantId && productJson && productJson.variants) {
      var pjVariant = productJson.variants.find(function(v){ return String(v.id) === String(variantId); });
      if (pjVariant) {
        managed = pjVariant.inventory_management || managed || '';
        policy  = pjVariant.inventory_policy || policy || '';
        if (pjVariant.inventory_quantity != null) {
          qty = parseInt(pjVariant.inventory_quantity, 10);
        }
      }
    }

    if (!managed && !policy) {
      var domVariantId = qInput && qInput.getAttribute('data-variant-id');
      if (!forVariantId || !domVariantId || String(domVariantId) === String(variantId)) {
        managed = qInput && qInput.getAttribute('data-inv-managed');
        policy  = qInput && qInput.getAttribute('data-inv-policy');
        var rawQty = parseInt(qInput && qInput.getAttribute('data-inv-qty'), 10);
        if (isNaN(qty)) qty = !isNaN(rawQty) ? rawQty : NaN;
      }
    }

    policy = policy || (variant && !forVariantId && variant.inventory_policy) || '';

    // If Shopify setting is "Continue selling when out of stock" ON, oversell is allowed: NO quantity cap!
    if (policy === 'continue') return false;

    // Ultra-reliable fallback: check visible stock badge — ONLY when not switching variants
    if (!forVariantId) {
      var stockTextEl = document.getElementById('stock-text');
      if (stockTextEl) {
        var match = stockTextEl.textContent.match(/Only\s+(\d+)\s+left/i);
        if (match) {
          var textQty = parseInt(match[1], 10);
          if (!isNaN(textQty)) {
            managed = managed || 'shopify';
            if (!policy || policy === '') policy = 'deny';
            qty = textQty;
          }
        }
      }
    }

    return !!(managed && managed !== '' && policy !== 'continue' && !isNaN(qty));
  }

  function showInvError(limit, itemTitle) {
    var title = itemTitle || 'this item';
    var msg = limit <= 0
      ? title + ' is currently unavailable. Please select another option.'
      : limit === 1
      ? 'Only 1 ' + title + ' is available. You cannot add more.'
      : 'Only ' + limit + ' ' + title + ' are available. You cannot add more.';
    if (window.TDCToast && window.TDCToast.warning) {
      window.TDCToast.warning(msg, 'Quantity limit reached');
    }
    // Also show an inline message that matches the desktop product mockup and stays accessible.
    var errEl = document.getElementById('inv-error');
    if (errEl) {
      errEl.innerHTML = '<span class="inv-alert-icon" aria-hidden="true">!</span><span class="inv-alert-copy"><strong>Quantity limit reached</strong><span>' + msg + '</span></span>';
      errEl.hidden = false;
      errEl.classList.add('inv-error--visible');
    }
    // Shake quantity widget
    var qtyWidget = document.querySelector('.qty.big');
    if (qtyWidget) {
      qtyWidget.classList.remove('qty-shake');
      void qtyWidget.offsetWidth;
      qtyWidget.classList.add('qty-shake');
    }
  }

  function clearInvError() {
    var errEl = document.getElementById('inv-error');
    if (!errEl) return;
    errEl.hidden = true;
    errEl.classList.remove('inv-error--visible');
    errEl.innerHTML = '';
  }

  function setQty(n) {
    var qInput = document.getElementById('quantity') || quantityInput;
    var variant = currentVariant();

    // ── SOLD-OUT GUARD ── If the current variant is not available, block qty > 1
    // and ensure the + button stays disabled so quantity can never be increased.
    if (variant && !variant.available) {
      var val = 1;
      if (qInput) qInput.value = val;
      var qOut = document.getElementById('qty') || qtyOutput;
      if (qOut) qOut.textContent = val;
      // Disable + button for sold-out variant
      var plusBtnEl = document.getElementById('qty-plus');
      if (plusBtnEl) plusBtnEl.disabled = true;
      clearInvError();
      return;
    }

    var invLimit = getInvLimit();
    var hasLimit = hasInventoryLimit();
    var variantId = variant ? variant.id : (variantIdInput ? variantIdInput.value : null);
    var cartQty = hasLimit ? getCartQtyForVariant(variantId) : 0;

    var min = parseInt(qInput && qInput.min, 10) || 1;
    // Cap max at (invLimit - cartQty) so displayed qty + cart qty never exceeds stock
    var effectiveMax = hasLimit ? Math.max(min, invLimit - cartQty) : (parseInt(qInput && qInput.max, 10) || 99);
    var max = Math.min(effectiveMax, parseInt(qInput && qInput.max, 10) || 99);
    max = Math.max(min, max);
    var val = Math.min(max, Math.max(min, n));
    if (qInput) qInput.value = val;
    var qOut = document.getElementById('qty') || qtyOutput;
    if (qOut) qOut.textContent = val;

    // Enable/disable + button based on whether adding 1 more would exceed the limit
    var plusBtnEl = document.getElementById('qty-plus');
    if (plusBtnEl) {
      var atLimit = hasLimit && (val + cartQty) >= invLimit;
      plusBtnEl.disabled = atLimit;
    }

    // Show or hide inventory error
    if (hasLimit && (n > max || (val + cartQty) > invLimit)) {
      var title = variant && variant.title && variant.title !== 'Default Title' ? variant.title : (productJson && productJson.title ? productJson.title : 'this item');
      showInvError(invLimit, title);
    } else {
      clearInvError();
    }
    if (variant) {
      var totalPrice = money(variant.price * val);
      var currentAddTotal = document.getElementById('add-total');
      if (currentAddTotal) {
        currentAddTotal.textContent = totalPrice;
      } else {
        var btnText = document.getElementById('add-btn-text');
        var addLabel = (window.theme && window.theme.translations && window.theme.translations.add_to_bag) || 'Add to bag';
        if (btnText) {
          btnText.innerHTML = addLabel + ' · <span id="add-total">' + totalPrice + '</span>';
        } else if (addToCartBtn) {
          addToCartBtn.innerHTML = addLabel + ' · <span id="add-total">' + totalPrice + '</span>';
        }
      }
    }
  }

  function updateVariantUrl(variantId) {
    var url = new URL(window.location.href);
    url.searchParams.set('variant', variantId);
    url.searchParams.delete('section_id');
    window.history.replaceState(window.history.state, '', url.toString());
  }

  function refreshVariantSection(variant) {
    var sectionId = page.getAttribute('data-section-id');
    if (!sectionId || !variant || !variant.id) return;

    var requestId = ++variantSectionRequest;
    var url = new URL(window.location.href);
    url.hash = '';
    url.searchParams.set('variant', variant.id);
    url.searchParams.set('section_id', sectionId);

    fetch(url.toString(), { headers: { Accept: 'text/html' } })
      .then(function (response) {
        if (!response.ok) throw new Error('Section Rendering API returned ' + response.status);
        return response.text();
      })
      .then(function (html) {
        if (requestId !== variantSectionRequest ||
            !variantIdInput ||
            String(variantIdInput.value) !== String(variant.id)) return;

        var rendered = new DOMParser().parseFromString(html, 'text/html');
        var renderedVariantId = rendered.getElementById('variant-id');
        var renderedQuantity = rendered.getElementById('quantity');
        if (!renderedVariantId || String(renderedVariantId.value) !== String(variant.id) || !renderedQuantity) {
          throw new Error('Rendered product section did not contain the requested variant');
        }

        var renderedStock = rendered.getElementById('stock');
        var renderedStockText = rendered.getElementById('stock-text');
        var renderedPrice = rendered.getElementById('p-price');
        var renderedSku = rendered.getElementById('p-sku');
        var renderedSkuValue = rendered.getElementById('p-sku-value');
        var renderedAddButton = rendered.getElementById('add-btn');
        var renderedBuyExtra = rendered.getElementById('buy-extra');
        var inventoryQuantity = parseInt(renderedQuantity.getAttribute('data-inv-qty'), 10);
        var inventoryManagement = renderedQuantity.getAttribute('data-inv-managed') || '';
        var inventoryPolicy = renderedQuantity.getAttribute('data-inv-policy') || '';
        var renderedPriceValue = parseInt(renderedVariantId.getAttribute('data-variant-price'), 10);
        var renderedComparePriceValue = parseInt(renderedVariantId.getAttribute('data-variant-compare-price'), 10);
        var productVariant = productJson && productJson.variants
          ? productJson.variants.find(function (item) { return String(item.id) === String(variant.id); })
          : null;

        if (quantityInput) {
          quantityInput.setAttribute('data-inv-qty', isNaN(inventoryQuantity) ? 0 : inventoryQuantity);
          quantityInput.setAttribute('data-inv-managed', inventoryManagement);
          quantityInput.setAttribute('data-inv-policy', inventoryPolicy);
        }
        if (!isNaN(inventoryQuantity)) {
          productInvMap[variant.id] = {
            qty: inventoryQuantity,
            management: inventoryManagement,
            policy: inventoryPolicy,
            title: variant.title
          };
          window._variantInventory = window._variantInventory || {};
          window._variantInventory[variant.id] = productInvMap[variant.id];
        }
        if (productVariant) {
          productVariant.inventory_quantity = isNaN(inventoryQuantity) ? 0 : inventoryQuantity;
          productVariant.inventory_management = inventoryManagement || null;
          productVariant.inventory_policy = inventoryPolicy;
          if (!isNaN(renderedPriceValue)) productVariant.price = renderedPriceValue;
          if (!isNaN(renderedComparePriceValue)) {
            productVariant.compare_at_price = renderedComparePriceValue || null;
          }
          if (renderedAddButton) productVariant.available = !renderedAddButton.disabled;
        }
        if (productVariant && stickyPrice) stickyPrice.textContent = money(productVariant.price);
        if (renderedStock && stockEl) stockEl.className = renderedStock.className;
        if (renderedStockText && stockText) stockText.textContent = renderedStockText.textContent;
        if (renderedPrice && priceEl) priceEl.innerHTML = renderedPrice.innerHTML;
        if (renderedSku && skuEl) skuEl.hidden = renderedSku.hidden;
        if (renderedSkuValue && skuValue) skuValue.textContent = renderedSkuValue.textContent;
        if (renderedAddButton && addToCartBtn) {
          addToCartBtn.disabled = renderedAddButton.disabled;
          addToCartBtn.classList.toggle('sold-out-btn', renderedAddButton.disabled);
          addToCartBtn.innerHTML = renderedAddButton.innerHTML;
        }
        if (renderedBuyExtra && buyExtra) buyExtra.hidden = renderedBuyExtra.hidden;
        if (renderedAddButton && stickyAdd) {
          stickyAdd.textContent = renderedAddButton.disabled ? 'Notify me' : 'Add to bag';
        }
        // ── Sync + button with freshly confirmed availability ──
        var plusBtnEl3 = document.getElementById('qty-plus');
        if (plusBtnEl3 && renderedAddButton) {
          plusBtnEl3.disabled = renderedAddButton.disabled;
        }
        updateSwatchAvailability();
      })
      .catch(function (error) {
        if (requestId !== variantSectionRequest) return;
        console.error('Unable to refresh product variant details.', error);
        if (window.TDCToast && window.TDCToast.warning) {
          window.TDCToast.warning(
            'Availability could not be refreshed. Please try selecting the option again.',
            'Availability update failed'
          );
        }
      });
  }

  function updateSwatchAvailability() {
    if (!productJson || !productJson.variants) return;
    var swatches = document.querySelectorAll('.pdp-page .swatch[data-option-value]');
    swatches.forEach(function (btn) {
      var optIdx = parseInt(btn.getAttribute('data-option-index'), 10);
      var val = btn.getAttribute('data-option-value');
      if (isNaN(optIdx) || !val) return;

      var proposedVariant = productJson.variants.find(function (v) {
        return productJson.options.every(function (optName, i) {
          var expectedVal = (i === optIdx) ? val : selectedOptions[i];
          return !expectedVal || v['option' + (i + 1)] === expectedVal;
        });
      });

      var isSold = false;
      if (proposedVariant) {
        var inv = (productInvMap && productInvMap[proposedVariant.id]) || (window._variantInventory && window._variantInventory[proposedVariant.id]);
        var mng = inv ? inv.management : (proposedVariant.inventory_management || '');
        var pol = inv ? inv.policy : (proposedVariant.inventory_policy || '');
        var q = inv && inv.qty != null ? inv.qty : (proposedVariant.inventory_quantity != null ? proposedVariant.inventory_quantity : null);
        if (mng && pol !== 'continue' && q != null) {
          isSold = q <= 0;
        } else {
          isSold = !proposedVariant.available;
        }
        btn.setAttribute('data-variant-id', proposedVariant.id);
      } else {
        var anyAvailable = productJson.variants.some(function (v) {
          if (v['option' + (optIdx + 1)] !== val) return false;
          var inv = (productInvMap && productInvMap[v.id]) || (window._variantInventory && window._variantInventory[v.id]);
          var mng = inv ? inv.management : (v.inventory_management || '');
          var pol = inv ? inv.policy : (v.inventory_policy || '');
          var q = inv && inv.qty != null ? inv.qty : (v.inventory_quantity != null ? v.inventory_quantity : null);
          if (mng && pol !== 'continue' && q != null) {
            return q > 0;
          }
          return !!v.available;
        });
        isSold = !anyAvailable;
      }

      btn.classList.toggle('sold', isSold);
    });
  }

  function applyVariant(variant) {
    if (!variant) return;
    if (variantIdInput) {
      variantIdInput.value = variant.id;
      try {
        variantIdInput.dispatchEvent(new Event('change', { bubbles: true }));
      } catch (e) {}
    }
    try {
      document.dispatchEvent(new CustomEvent('variant:change', {
        bubbles: true,
        detail: { variant: variant, product: productJson }
      }));
    } catch (e) {}
    if (priceEl) {
      var html = money(variant.price);
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        var pct = Math.round(((variant.compare_at_price - variant.price) / variant.compare_at_price) * 100);
        html += ' <span class="compare-price" id="compare-price">' + money(variant.compare_at_price) + '</span>';
        if (pct > 0) {
          html += ' <span class="price-save" id="price-save">Save ' + pct + '%</span>';
        }
      }
      priceEl.innerHTML = html;
    }
    if (stickyPrice) stickyPrice.textContent = money(variant.price);
    if (stickyTitle) stickyTitle.textContent = productJson.title;
    if (skuEl && skuValue) {
      skuValue.textContent = variant.sku || '';
      skuEl.hidden = !variant.sku;
    }
    // Update inventory data attributes for the new variant.
    // IMPORTANT: invData may be null if the Section Rendering API fetch for this
    // variant has not returned yet. In that case we fall back to variant.available
    // (Shopify's own availability flag) so we never wrongly mark an in-stock
    // variant as sold-out just because invQty defaults to 0.
    var invData = (variant && productInvMap[variant.id]) || (variant && window._variantInventory && window._variantInventory[variant.id]) || null;
    // Only use invQty from productInvMap/window._variantInventory; if invData is absent
    // fall back to variant.inventory_quantity but ONLY when it is a positive number.
    // Never default to 0 — that would block add-to-cart for available variants.
    var invQty;
    if (invData && invData.qty != null) {
      invQty = parseInt(invData.qty, 10);
    } else if (variant.inventory_quantity != null && variant.inventory_quantity > 0) {
      invQty = parseInt(variant.inventory_quantity, 10);
    } else {
      // invData not yet loaded — use a sentinel that means "unknown / trust variant.available"
      invQty = invData ? 0 : -1;
    }
    var invManaged = invData ? invData.management : (variant.inventory_management || '');
    var invPolicy = invData ? invData.policy : (variant.inventory_policy || '');

    var qInput = document.getElementById('quantity') || quantityInput;
    if (qInput) {
      qInput.setAttribute('data-inv-qty', invQty >= 0 ? invQty : 0);
      qInput.setAttribute('data-inv-managed', invManaged);
      qInput.setAttribute('data-inv-policy', invPolicy);
      // Track which variant's data is currently in the DOM attributes
      qInput.setAttribute('data-variant-id', variant.id);
    }
    clearInvError();

    // ── Reset button state on every variant switch ──────────────────────────
    // When switching FROM a sold-out / at-limit variant, we must remove any
    // atc-limit class and sticky error so the new variant doesn't inherit the
    // old variant's disabled appearance.
    var _atcBtn = document.getElementById('add-btn');
    if (_atcBtn) {
      _atcBtn.classList.remove('atc-limit', 'added', 'is-adding');
      _atcBtn.disabled = false;
    }
    if (stickyAdd) {
      stickyAdd.classList.remove('atc-limit', 'added', 'is-adding');
      stickyAdd.disabled = false;
    }
    var _stickyErr = document.getElementById('sticky-inv-error');
    if (_stickyErr) _stickyErr.hidden = true;

    setQty(1); // Reset to 1 on variant change

    // hasLimit: inventory is actively managed AND oversell is blocked
    var hasLimit = !!(invManaged && invPolicy !== 'continue');
    // available: trust variant.available as primary signal.
    // When invPolicy === 'continue', available is always variant.available (never forced sold out)
    var available = !!variant.available && (!hasLimit || invQty < 0 || invQty > 0);
    // qtyLeft: actual quantity in stock
    var qtyLeft = invQty >= 0 ? invQty : 99;
    // show_low_stock: when inventory is managed and stock is 1-12 (regardless of continue policy, matching collection badge)
    var showLowStock = !!invManaged && qtyLeft > 0 && qtyLeft <= 12;
    // continue_selling: oversell is allowed — show special "available to order" message
    var isContinueSelling = invPolicy === 'continue';

    if (stockEl) {
      stockEl.classList.toggle('out', !available);
      stockEl.classList.toggle('low', available && showLowStock && !isContinueSelling);
      stockEl.classList.toggle('continue', available && isContinueSelling);
    }
    if (stockText) {
      var stockMsg;
      if (!available) {
        stockMsg = 'Sold out';
      } else if (isContinueSelling) {
        // "Continue selling when out of stock" is ON — show friendly backorder/pre-order message
        if (showLowStock) {
          stockMsg = 'Only ' + qtyLeft + ' in stock — you can still order more';
        } else {
          stockMsg = 'Available to order — ships even when stock runs low';
        }
      } else if (showLowStock) {
        stockMsg = 'Only ' + qtyLeft + ' left, ready to ship';
      } else {
        stockMsg = 'In stock, ready to ship';
      }
      stockText.textContent = stockMsg;
    }

    if (buyExtra) buyExtra.hidden = !available;
    if (notify) notify.hidden = available;

    if (addToCartBtn) {
      addToCartBtn.disabled = !available;
      addToCartBtn.classList.toggle('sold-out-btn', !available);
      var btnText = document.getElementById('add-btn-text');
      var val = parseInt(quantityInput && quantityInput.value, 10) || 1;
      if (available) {
        var addLabel = (window.theme && window.theme.translations && window.theme.translations.add_to_bag) || 'Add to bag';
        if (btnText) {
          btnText.innerHTML = addLabel + ' · <span id="add-total">' + money(variant.price * val) + '</span>';
        } else {
          addToCartBtn.innerHTML = addLabel + ' · <span id="add-total">' + money(variant.price * val) + '</span>';
        }
      } else {
        var soldLabel = (window.theme && window.theme.translations && window.theme.translations.sold_out) || 'Sold out';
        if (btnText) {
          btnText.textContent = soldLabel;
        } else {
          addToCartBtn.textContent = soldLabel;
        }
      }
    }

    // ── Sync + / − buttons with availability ──
    var plusBtnEl2 = document.getElementById('qty-plus');
    var minusBtnEl = document.getElementById('qty-minus');
    if (plusBtnEl2) {
      if (!available) {
        plusBtnEl2.disabled = true;
      } else {
        // Even if available, check cart-aware limit using THIS variant's id explicitly
        var cartQtyForVariant = getCartQtyForVariant(variant.id);
        var invLimitForVariant = getInvLimit(variant.id);
        var hasLimitForVariant = hasInventoryLimit(variant.id);
        plusBtnEl2.disabled = hasLimitForVariant && cartQtyForVariant >= invLimitForVariant;
      }
    }
    if (minusBtnEl) minusBtnEl.disabled = false; // minus always enabled (min=1)

    if (stickyAdd) stickyAdd.textContent = available ? 'Add to bag' : 'Notify me';

    if (variant.featured_image) {
      var match = media.findIndex(function (m) { return m.src && variant.featured_image.src && m.src.indexOf(variant.featured_image.src.split('?')[0].split('/').pop()) > -1; });
      if (match < 0) match = media.findIndex(function (m) { return String(m.id) === String(variant.featured_image.id); });
      if (match >= 0) showMedia(match);
    }
    updateVariantUrl(variant.id);
    updateSwatchAvailability();
    refreshVariantSection(variant);
  }

  if (thumbs) {
    thumbs.addEventListener('click', function (e) {
      var b = e.target.closest('.thumb-btn');
      if (!b) return;
      e.preventDefault();
      showMedia(parseInt(b.getAttribute('data-i'), 10));
    });
  }

  // Use native scrolling so thumbnail selection and slider navigation share one source of truth.
  var thumbContainer = document.querySelector('.thumbs-container');
  if (thumbContainer && thumbContainer.classList.contains('has-slider')) {
    var thumbPrev = thumbContainer.querySelector('.thumb-nav-prev');
    var thumbNext = thumbContainer.querySelector('.thumb-nav-next');
    var thumbsWrapper = thumbContainer.querySelector('#thumbs');

    if (thumbPrev && thumbNext && thumbsWrapper) {
      function updateThumbSlider() {
        var isHorizontal = window.matchMedia('(max-width: 1080px)').matches;
        var position = isHorizontal ? thumbsWrapper.scrollLeft : thumbsWrapper.scrollTop;
        var maximum = isHorizontal
          ? thumbsWrapper.scrollWidth - thumbsWrapper.clientWidth
          : thumbsWrapper.scrollHeight - thumbsWrapper.clientHeight;
        thumbPrev.disabled = position <= 2;
        thumbNext.disabled = position >= maximum - 2;
      }

      function moveThumbs(direction) {
        var firstThumb = thumbsWrapper.querySelector('.thumb-btn');
        if (!firstThumb) return;
        var styles = window.getComputedStyle(thumbsWrapper);
        var gap = parseFloat(styles.gap) || 0;
        var isHorizontal = window.matchMedia('(max-width: 1080px)').matches;
        var distance = (isHorizontal ? firstThumb.offsetWidth : firstThumb.offsetHeight) + gap;
        var viewportSize = isHorizontal ? thumbsWrapper.clientWidth : thumbsWrapper.clientHeight;
        var visibleCount = Math.max(1, Math.floor((viewportSize + gap) / distance));
        thumbsWrapper.scrollBy(isHorizontal
          ? { left: direction * distance * visibleCount, behavior: 'smooth' }
          : { top: direction * distance * visibleCount, behavior: 'smooth' });
      }

      function syncThumbSliderHeight() {
        if (window.matchMedia('(max-width: 1080px)').matches) {
          thumbContainer.style.removeProperty('--gallery-stage-height');
          return;
        }
        var stage = page.querySelector('.stage-btn');
        if (stage && stage.offsetHeight) {
          thumbContainer.style.setProperty('--gallery-stage-height', stage.offsetHeight + 'px');
        }
      }

      thumbPrev.addEventListener('click', function () { moveThumbs(-1); });
      thumbNext.addEventListener('click', function () { moveThumbs(1); });
      thumbsWrapper.addEventListener('scroll', function () {
        window.requestAnimationFrame(updateThumbSlider);
      }, { passive: true });
      syncThumbSliderHeight();
      updateThumbSlider();
      if (typeof ResizeObserver === 'function') {
        var stageObserver = new ResizeObserver(syncThumbSliderHeight);
        var stage = page.querySelector('.stage-btn');
        if (stage) stageObserver.observe(stage);
      }
      window.addEventListener('resize', function () {
        syncThumbSliderHeight();
        updateThumbSlider();
      });
    }
  }
  var stagePrev = document.getElementById('stage-prev');
  var stageNext = document.getElementById('stage-next');
  if (stagePrev) stagePrev.addEventListener('click', function (e) { e.preventDefault(); showMedia(idx - 1); });
  if (stageNext) stageNext.addEventListener('click', function (e) { e.preventDefault(); showMedia(idx + 1); });

  function openLightbox() {
    if (!lightbox) return;
    lightbox.classList.add('is-open');
    document.documentElement.classList.add('is-locked');
  }
  function closeLightbox() {
    if (!lightbox) return;
    lightbox.classList.remove('is-open');
    document.documentElement.classList.remove('is-locked');
  }
  if (stageBtn) stageBtn.addEventListener('click', openLightbox);
  if (lightbox) {
    lightbox.querySelectorAll('[data-close-lightbox]').forEach(function (btn) {
      btn.addEventListener('click', closeLightbox);
    });
  }
  var lbPrev = document.getElementById('lb-prev');
  var lbNext = document.getElementById('lb-next');
  if (lbPrev) lbPrev.addEventListener('click', function () { showMedia(idx - 1); });
  if (lbNext) lbNext.addEventListener('click', function () { showMedia(idx + 1); });
  document.addEventListener('keydown', function (e) {
    if (!lightbox || !lightbox.classList.contains('is-open')) return;
    if (e.key === 'Escape') closeLightbox();
    if (e.key === 'ArrowRight') showMedia(idx + 1);
    if (e.key === 'ArrowLeft') showMedia(idx - 1);
  });

  document.querySelectorAll('.pdp-page .swatch[data-option-value]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var optionIndex = parseInt(btn.getAttribute('data-option-index'), 10);
      var value = btn.getAttribute('data-option-value');
      if (isNaN(optionIndex) || !value) return;

      selectedOptions[optionIndex] = value;

      // 1. Try finding exact variant match for current selectedOptions:
      var variant = productJson && productJson.variants
        ? productJson.variants.find(function (v) {
            return selectedOptions.every(function (opt, i) {
              return !opt || v['option' + (i + 1)] === opt;
            });
          })
        : null;

      // 2. If no exact combination exists, pick best variant matching clicked option:
      if (!variant && productJson && productJson.variants) {
        variant = productJson.variants.find(function (v) {
          return v['option' + (optionIndex + 1)] === value && v.available;
        }) || productJson.variants.find(function (v) {
          return v['option' + (optionIndex + 1)] === value;
        });
      }

      if (variant) {
        // Sync selectedOptions to the matched variant
        if (productJson && productJson.options) {
          productJson.options.forEach(function (optName, i) {
            selectedOptions[i] = variant['option' + (i + 1)];
          });
        }

        // Sync aria-checked and labels on all swatch groups:
        document.querySelectorAll('.pdp-page .swatch-group[data-option-index]').forEach(function (grp) {
          var grpIdx = parseInt(grp.getAttribute('data-option-index'), 10);
          var activeVal = selectedOptions[grpIdx];
          if (activeVal) {
            var label = grp.querySelector('[data-option-label]');
            if (label) label.textContent = activeVal;
            grp.querySelectorAll('.swatch').forEach(function (s) {
              var sVal = s.getAttribute('data-option-value');
              s.setAttribute('aria-checked', sVal === activeVal ? 'true' : 'false');
            });
          }
        });

        applyVariant(variant);
      }
    });
  });

  // Initial sync of swatch sold status on page load:
  updateSwatchAvailability();

  var minusBtn = document.getElementById('qty-minus');
  var plusBtn = document.getElementById('qty-plus');

  // Immediately sync + button disabled state on page load if stock is 1 or already in cart
  if (plusBtn) {
    var initInvLimit = getInvLimit();
    var initHasLimit = hasInventoryLimit();
    var initVariant = currentVariant();
    var initVariantId = initVariant ? initVariant.id : (variantIdInput ? variantIdInput.value : null);
    var initCartQty = initHasLimit
      ? (window.TDCCartGuard ? window.TDCCartGuard.getEffectiveCartQty(initVariantId) : getCartQtyForVariant(initVariantId))
      : 0;
    var initQty = parseInt((document.getElementById('quantity') || {}).value, 10) || 1;
    if (initHasLimit && (initQty + initCartQty) >= initInvLimit) {
      plusBtn.disabled = true;
    }
  }

  if (minusBtn) minusBtn.addEventListener('click', function () {
    var qInput = document.getElementById('quantity') || quantityInput;
    setQty((parseInt(qInput && qInput.value, 10) || 1) - 1);
    // After decrement, clear error so user knows they can add again
    clearInvError();
  });

  if (plusBtn) plusBtn.addEventListener('click', function () {
    var qInput = document.getElementById('quantity') || quantityInput;
    var currentVal = parseInt(qInput && qInput.value, 10) || 1;
    var variant = currentVariant();

    // Block if variant is sold out
    if (variant && !variant.available) {
      plusBtn.disabled = true;
      return;
    }

    var invLimit = getInvLimit();
    var hasLimit = hasInventoryLimit();
    var variantId = variant ? variant.id : (variantIdInput ? variantIdInput.value : null);
    // Use TDCCartGuard for effective qty (confirmed + in-flight) to prevent rapid-click bypass
    var cartQty = 0;
    if (hasLimit) {
      cartQty = window.TDCCartGuard
        ? window.TDCCartGuard.getEffectiveCartQty(variantId)
        : getCartQtyForVariant(variantId);
    }

    if (hasLimit && (currentVal + 1 + cartQty) > invLimit) {
      var title = variant && variant.title && variant.title !== 'Default Title'
        ? variant.title
        : (productJson && productJson.title ? productJson.title : 'this item');
      showInvError(invLimit, title);
      plusBtn.disabled = true; // Disable button when at limit
      return;
    }
    setQty(currentVal + 1);
  });

  var qInputEl = document.getElementById('quantity');
  if (qInputEl) {
    qInputEl.addEventListener('change', function () {
      setQty(parseInt(qInputEl.value, 10) || 1);
    });
    qInputEl.addEventListener('input', function () {
      setQty(parseInt(qInputEl.value, 10) || 1);
    });
  }

  var saveBtn = document.getElementById('save-btn');
  if (saveBtn) {
    saveBtn.addEventListener('click', function () {
      var on = saveBtn.getAttribute('aria-pressed') !== 'true';
      saveBtn.setAttribute('aria-pressed', on);
      var span = saveBtn.querySelector('span');
      if (span) span.textContent = on ? 'Saved to wishlist' : 'Save to wishlist';
    });
  }

  function addToCart(id, qty) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: id, quantity: qty })
    }).then(function (res) {
      if (!res.ok) {
        return res.json().then(function (errJson) {
          var msg = errJson.description || errJson.message || 'Add to cart failed';
          var err = new Error(msg);
          err.data = errJson;
          throw err;
        });
      }
      return res.json();
    }).then(function (addedItem) {
      if (addedItem && addedItem.id && productInvMap[addedItem.id]) {
        window._variantInventory = window._variantInventory || {};
        window._variantInventory[addedItem.id] = productInvMap[addedItem.id];
      }
      if (window.TDCCart && window.TDCCart.fetch) return window.TDCCart.fetch();
    }).then(function () {
      if (window.TDCOverlay && window.TDCOverlay.open) window.TDCOverlay.open('cart');
    });
  }

  // if (productForm) {
  //   productForm.addEventListener('submit', function (e) {
  //     var variant = currentVariant();
      
  //     if (!variant || !variant.available) {
  //       var isAppAction = e.submitter && (
  //         e.submitter.id !== 'add-btn' ||
  //         e.submitter.classList.contains('globo-preorder-btn') ||
  //         e.submitter.classList.contains('gpo-button')
  //       );
  //       if (!isAppAction && (!addToCartBtn || addToCartBtn.disabled)) {
  //         e.preventDefault();
  //       }
  //       return;
  //     }
  //     e.preventDefault();
  //     var variantId = variantIdInput ? variantIdInput.value : null;
  //     var qty = quantityInput ? parseInt(quantityInput.value, 10) : 1;
  //     if (!variantId) return;

  //     var invLimit = getInvLimit(variantId);
  //     var hasLimit = hasInventoryLimit(variantId);
  //     var title = variant && variant.title && variant.title !== 'Default Title' ? variant.title : (productJson && productJson.title ? productJson.title : 'this item');

  //     // ── Optimistic stock guard (prevents rapid-click double-adds) ──────────
  //     // Use TDCCartGuard which tracks in-flight (pending) quantities so rapid
  //     // clicks are blocked even before the AJAX response arrives.
  //     var guardLimit = hasLimit ? invLimit : Infinity;
  //     if (window.TDCCartGuard && !window.TDCCartGuard.canAdd(variantId, qty, guardLimit)) {
  //       var effectiveCartQty = window.TDCCartGuard.getEffectiveCartQty(variantId);
  //       showInvError(invLimit, title);
  //       var qtyWidget = document.querySelector('.qty.big');
  //       if (qtyWidget) {
  //         qtyWidget.classList.remove('qty-shake');
  //         void qtyWidget.offsetWidth;
  //         qtyWidget.classList.add('qty-shake');
  //       }
  //       return;
  //     }

  //     // Legacy guard (fallback when TDCCartGuard not loaded yet)
  //     if (hasLimit) {
  //       var cartQty = getCartQtyForVariant(variantId);
  //       if (cartQty >= invLimit || (qty + cartQty) > invLimit || qty > invLimit) {
  //         showInvError(invLimit, title);
  //         var qtyWidget = document.querySelector('.qty.big');
  //         if (qtyWidget) {
  //           qtyWidget.classList.remove('qty-shake');
  //           void qtyWidget.offsetWidth;
  //           qtyWidget.classList.add('qty-shake');
  //         }
  //         return;
  //       }
  //     }
  //     // ── End stock guard ────────────────────────────────────────────────────

  //     // Reserve qty optimistically BEFORE the AJAX call
  //     if (window.TDCCartGuard) window.TDCCartGuard.reserve(variantId, qty);

  //     var prev = addToCartBtn ? addToCartBtn.innerHTML : '';
  //     if (addToCartBtn) {
  //       addToCartBtn.disabled = true;
  //       addToCartBtn.classList.add('added', 'is-adding');
  //       addToCartBtn.textContent = 'Adding...';
  //     }
  //     if (stickyAdd) {
  //       stickyAdd.disabled = true;
  //       stickyAdd.classList.add('is-adding');
  //       stickyAdd.textContent = 'Adding...';
  //     }
  //     addToCart(variantId, qty).then(function () {
  //       // Confirm the reservation (cart has been refreshed with real qty)
  //       if (window.TDCCartGuard) window.TDCCartGuard.confirm(variantId, qty);
  //       // Show success toast
  //       var variant = currentVariant();
  //       var title = variant && variant.title && variant.title !== 'Default Title' ? variant.title : (productJson && productJson.title ? productJson.title : 'Item');
  //       if (window.TDCToast && window.TDCToast.success) {
  //         window.TDCToast.success(title + ' added to your bag', 'Added to bag');
  //       }
  //       if (addToCartBtn) {
  //         addToCartBtn.textContent = 'Added ✓';
  //         addToCartBtn.classList.remove('is-adding');
  //         setTimeout(function () {
  //           addToCartBtn.classList.remove('added');
  //           addToCartBtn.innerHTML = prev;
  //           addToCartBtn.disabled = false;
  //           var currentVal = parseInt((document.getElementById('quantity') || {}).value, 10) || 1;
  //           setQty(currentVal);
  //           // Refresh PDP buttons from updated cart
  //           if (typeof refreshPdpButtonsFromCart === 'function') refreshPdpButtonsFromCart();
  //         }, 1600);
  //       }
  //       if (stickyAdd) {
  //         stickyAdd.classList.remove('is-adding');
  //         stickyAdd.classList.add('added');
  //         stickyAdd.textContent = 'Added ✓';
  //         setTimeout(function () {
  //           stickyAdd.classList.remove('added');
  //           stickyAdd.textContent = 'Add to bag';
  //           stickyAdd.disabled = false;
  //         }, 1600);
  //       }
  //     }).catch(function (err) {
  //       // Release the reservation on failure
  //       if (window.TDCCartGuard) window.TDCCartGuard.release(variantId, qty);
  //       if (addToCartBtn) {
  //         addToCartBtn.classList.remove('added', 'is-adding');
  //         addToCartBtn.innerHTML = prev;
  //         addToCartBtn.disabled = false;
  //         var currentVal = parseInt((document.getElementById('quantity') || {}).value, 10) || 1;
  //         setQty(currentVal);
  //       }
  //       if (stickyAdd) {
  //         stickyAdd.classList.remove('is-adding', 'added');
  //         stickyAdd.textContent = 'Add to bag';
  //         stickyAdd.disabled = false;
  //       }
  //       var variant = currentVariant();
  //       var title = variant && variant.title && variant.title !== 'Default Title' ? variant.title : (productJson && productJson.title ? productJson.title : 'this item');
  //       var invLimit = getInvLimit();
  //       showInvError(invLimit, title);
  //       if (window.TDCToast && window.TDCToast.warning && err && err.message) {
  //         window.TDCToast.warning(err.message, 'Quantity limit reached');
  //       }
  //     });
  //   });
  // }

  if (productForm) {
    productForm.addEventListener('submit', function (e) {
      var submitter = e.submitter;
      // Preserve app-specific form actions
      if (
        submitter &&
        submitter.id !== 'add-btn' &&
        !submitter.classList.contains('globo-preorder-btn') &&
        !submitter.classList.contains('gpo-button')
      ) {
        return;
      }
      var variant = currentVariant();
      if (!variant || !variant.available) {
        if (!submitter || submitter.id === 'add-btn') {
          e.preventDefault();
        }
        return;
      }
      e.preventDefault();
      // Prevent duplicate requests while checking or adding
      if (productForm.dataset.stockChecking === 'true') return;
      var variantId = String(
        variantIdInput ? variantIdInput.value : variant.id
      );
      var qty = Math.max(
        1,
        parseInt(quantityInput && quantityInput.value, 10) || 1
      );
      var invLimit = getInvLimit(variantId);
      var hasLimit = hasInventoryLimit(variantId);
      var title =
        variant.title && variant.title !== 'Default Title'
          ? variant.title
          : (productJson && productJson.title) || 'this item';
      productForm.dataset.stockChecking = 'true';
      // Always check the latest cart before adding
      fetch('/cart.js', {
        method: 'GET',
        headers: { Accept: 'application/json' },
        cache: 'no-store'
      })
        .then(function (response) {
          if (!response.ok) {
            throw new Error('Unable to verify cart quantity.');
          }
          return response.json();
        })
        .then(function (cart) {
          var cartQty = (cart.items || []).reduce(function (total, item) {
            return String(item.variant_id) === variantId
              ? total + Number(item.quantity || 0)
              : total;
          }, 0);
          // Block before sending /cart/add.js
          if (hasLimit && cartQty + qty > invLimit) {
            showInvError(invLimit, title);

            var qtyWidget = document.querySelector('.qty.big');
            if (qtyWidget) {
              qtyWidget.classList.remove('qty-shake');
              void qtyWidget.offsetWidth;
              qtyWidget.classList.add('qty-shake');
            }

            if (window.TDCCartGuard) {
              window.TDCCartGuard.confirm(variantId, cartQty);
            }

            if (typeof refreshPdpButtonsFromCart === 'function') {
              refreshPdpButtonsFromCart();
            }

            return;
          }

          // Recheck current variant before proceeding
          var current = currentVariant();
          if (!current || String(current.id) !== variantId || !current.available) {
            return;
          }

          // Reserve quantity before the AJAX add request
          if (window.TDCCartGuard) {
            var guardLimit = hasLimit ? invLimit : Infinity;

            if (!window.TDCCartGuard.canAdd(variantId, qty, guardLimit)) {
              showInvError(invLimit, title);
              return;
            }

            window.TDCCartGuard.reserve(variantId, qty);
          }

          var prev = addToCartBtn ? addToCartBtn.innerHTML : '';

          if (addToCartBtn) {
            addToCartBtn.disabled = true;
            addToCartBtn.classList.add('added', 'is-adding');
            addToCartBtn.textContent = 'Adding...';
          }

          if (stickyAdd) {
            stickyAdd.disabled = true;
            stickyAdd.classList.add('is-adding');
            stickyAdd.textContent = 'Adding...';
          }

          return addToCart(variantId, qty)
            .then(function () {
              if (window.TDCCartGuard) {
                window.TDCCartGuard.confirm(variantId, qty);
              }

              if (window.TDCToast && window.TDCToast.success) {
                window.TDCToast.success(
                  title + ' added to your bag',
                  'Added to bag'
                );
              }

              if (addToCartBtn) {
                addToCartBtn.textContent = 'Added ✓';
                addToCartBtn.classList.remove('is-adding');

                setTimeout(function () {
                  addToCartBtn.classList.remove('added');
                  addToCartBtn.innerHTML = prev;
                  addToCartBtn.disabled = false;

                  var currentQty = parseInt(
                    (document.getElementById('quantity') || {}).value,
                    10
                  ) || 1;

                  setQty(currentQty);
                  refreshPdpButtonsFromCart();
                }, 1600);
              }

              if (stickyAdd) {
                stickyAdd.classList.remove('is-adding');
                stickyAdd.classList.add('added');
                stickyAdd.textContent = 'Added ✓';

                setTimeout(function () {
                  stickyAdd.classList.remove('added');
                  stickyAdd.textContent = 'Add to bag';
                  stickyAdd.disabled = false;
                }, 1600);
              }

              if (window.TDCCart && window.TDCCart.fetch) {
                return window.TDCCart.fetch();
              }
            })
            .catch(function (err) {
              if (window.TDCCartGuard) {
                window.TDCCartGuard.release(variantId, qty);
              }

              if (addToCartBtn) {
                addToCartBtn.classList.remove('added', 'is-adding');
                addToCartBtn.innerHTML = prev;
                addToCartBtn.disabled = false;
              }

              if (stickyAdd) {
                stickyAdd.classList.remove('is-adding', 'added');
                stickyAdd.textContent = 'Add to bag';
                stickyAdd.disabled = false;
              }

              if (window.TDCToast && window.TDCToast.warning) {
                window.TDCToast.warning(
                  err.message || 'Please try again.',
                  'Unable to add item'
                );
              }
            });
        })
        .catch(function (err) {
          console.error('Stock check failed:', err);

          if (window.TDCToast && window.TDCToast.warning) {
            window.TDCToast.warning(
              'Could not verify stock. Please try again.',
              'Stock verification failed'
            );
          }
        })
        .finally(function () {
          productForm.dataset.stockChecking = 'false';
        });
    });
  }


  if (stickyAdd) {
    stickyAdd.addEventListener('click', function () {
      var variant = currentVariant();
      if (!variant || !variant.available) {
        // Scroll to sold-out / notify area
        var targetEl = document.querySelector('.globo-preorder-btn, .gpo-button, #notify-me-app-hook, #add-btn');
        if (targetEl) targetEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }

      // ── Stock pre-check for sticky buy ──────────────────────────────────
      var variantId = variantIdInput ? variantIdInput.value : (variant ? String(variant.id) : null);
      var invLimit = getInvLimit(variantId);
      var hasLimit = hasInventoryLimit(variantId);
      var guardLimit = hasLimit ? invLimit : Infinity;

      if (variantId && window.TDCCartGuard && !window.TDCCartGuard.canAdd(variantId, 1, guardLimit)) {
        // Cart is already at inventory limit — show error in both sticky bar and main product area
        var title = variant && variant.title && variant.title !== 'Default Title'
          ? variant.title
          : (productJson && productJson.title ? productJson.title : 'this item');
        // Show error in sticky bar
        var stickyErrEl = document.getElementById('sticky-inv-error');
        if (stickyErrEl) {
          var stickyMsg = invLimit <= 1
            ? 'Only 1 available — already in your bag'
            : 'Quantity limit reached — only ' + invLimit + ' available';
          stickyErrEl.textContent = stickyMsg;
          stickyErrEl.hidden = false;
          setTimeout(function () { if (stickyErrEl) stickyErrEl.hidden = true; }, 4000);
        }
        // Also show in main product area
        showInvError(invLimit, title);
        stickyAdd.classList.add('qty-shake');
        setTimeout(function () { stickyAdd.classList.remove('qty-shake'); }, 600);
        return;
      }

      // Legacy fallback: when TDCCartGuard not loaded, check confirmed cart qty
      if (!window.TDCCartGuard && hasLimit) {
        var confirmedCartQty = getCartQtyForVariant(variantId);
        if (confirmedCartQty >= invLimit) {
          var title2 = variant && variant.title && variant.title !== 'Default Title'
            ? variant.title
            : (productJson && productJson.title ? productJson.title : 'this item');
          var stickyErrEl2 = document.getElementById('sticky-inv-error');
          if (stickyErrEl2) {
            stickyErrEl2.textContent = 'Quantity limit reached';
            stickyErrEl2.hidden = false;
            setTimeout(function () { if (stickyErrEl2) stickyErrEl2.hidden = true; }, 4000);
          }
          showInvError(invLimit, title2);
          stickyAdd.classList.add('qty-shake');
          setTimeout(function () { stickyAdd.classList.remove('qty-shake'); }, 600);
          return;
        }
      }
      // ── End stock pre-check ─────────────────────────────────────────────

      if (addToCartBtn) addToCartBtn.click();
    });
  }

  if (sticky && 'IntersectionObserver' in window) {
    var observeEl = buyRow && !buyRow.hidden ? buyRow : notify;
    if (observeEl) {
      new IntersectionObserver(function (entries) {
        var entry = entries[0];
        var show = entry.boundingClientRect.bottom < 12;
        sticky.classList.toggle('is-on', show);
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        if (stickyAdd) stickyAdd.tabIndex = show ? 0 : -1;
      }, { threshold: [0, 1] }).observe(observeEl);
    }
  }

  function flockUpdate() {
    var boxes = document.querySelectorAll('[data-flock-id]');
    var sum = 0;
    var count = 0;
    var checked = [];
    boxes.forEach(function (c) {
      if (c.checked) {
        sum += parseInt(c.getAttribute('data-flock-price'), 10) || 0;
        count += 1;
        checked.push(c);
      }
    });
    var countEl = document.getElementById('flock-count');
    var priceElFlock = document.getElementById('flock-price');
    if (countEl) countEl.textContent = count + (count === 1 ? ' piece' : ' pieces');
    if (priceElFlock) priceElFlock.textContent = money(sum);
    // Return ALL checked items (disabled+checked = current product must also be included)
    return checked;
  }
  document.querySelectorAll('[data-flock-id]').forEach(function (c) {
    c.addEventListener('change', flockUpdate);
  });
  var flockAdd = document.getElementById('flock-add');
  if (flockAdd) {
    flockAdd.addEventListener('click', function () {
      var checked = flockUpdate();
      var items = checked.map(function (c) {
        return { id: parseInt(c.getAttribute('data-flock-id'), 10), quantity: 1 };
      });
      if (!items.length) return;

      // — Loading state —
      var origText = flockAdd.textContent;
      flockAdd.disabled = true;
      flockAdd.textContent = 'Adding…';
      flockAdd.classList.add('is-adding');

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (res) {
        if (!res.ok) throw new Error('Add failed');
        return res.json();
      }).then(function () {
        // — Success state —
        flockAdd.textContent = 'Added to bag ✓';
        flockAdd.classList.remove('is-adding');
        flockAdd.classList.add('is-added');
        if (window.TDCCart && window.TDCCart.fetch) return window.TDCCart.fetch();
      }).then(function () {
        if (window.TDCOverlay && window.TDCOverlay.open) window.TDCOverlay.open('cart');
        // Reset button after 2.5 s
        setTimeout(function () {
          flockAdd.textContent = origText;
          flockAdd.disabled = false;
          flockAdd.classList.remove('is-added');
        }, 2500);
      }).catch(function () {
        // — Error state —
        flockAdd.textContent = 'Something went wrong — try again';
        flockAdd.classList.remove('is-adding');
        flockAdd.classList.add('is-error');
        setTimeout(function () {
          flockAdd.textContent = origText;
          flockAdd.disabled = false;
          flockAdd.classList.remove('is-error');
        }, 3000);
      });
    });
    flockUpdate();
  }

  page.querySelectorAll('.accordions details').forEach(function (details) {
    var summary = details.querySelector('summary');
    var panel = details.querySelector('.accordion-panel');
    if (!summary || !panel) return;

    // Remove forced open state - let details start in natural state
    // details.setAttribute('open', ''); // REMOVED
    details.classList.remove('is-open');
    summary.setAttribute('aria-expanded', details.open ? 'true' : 'false');

    summary.addEventListener('click', function (e) {
      e.preventDefault();
      // Toggle the details element's open state
      details.open = !details.open;
      // Update ARIA attribute to match
      summary.setAttribute('aria-expanded', details.open ? 'true' : 'false');
    });
  });

  // ── PDP Cart-Aware Button Refresh ──────────────────────────────────────────
  // After cart is fetched (page load or after add/remove), re-evaluate whether
  // the current variant's qty in cart has hit the inventory limit.
  // This ensures "QUANTITY LIMIT REACHED" shows correctly, the + button is disabled,
  // and the Add to Bag & Sticky Buy buttons show "In bag" (disabled) when full.
  function refreshPdpButtonsFromCart() {
    var variant = currentVariant();
    if (!variant) return;

    // If variant is sold out, always ensure + is disabled and ATC shows sold out
    if (!variant.available) {
      var plusBtnEl = document.getElementById('qty-plus');
      if (plusBtnEl) plusBtnEl.disabled = true;
      var addBtnEl = document.getElementById('add-btn');
      if (addBtnEl) {
        addBtnEl.disabled = true;
        addBtnEl.classList.add('sold-out-btn');
        var btnText = document.getElementById('add-btn-text');
        var soldLabel = (window.theme && window.theme.translations && window.theme.translations.sold_out) || 'Sold out';
        if (btnText) btnText.textContent = soldLabel;
        else addBtnEl.textContent = soldLabel;
      }
      if (stickyAdd) {
        stickyAdd.disabled = true;
        stickyAdd.textContent = (window.theme && window.theme.translations && window.theme.translations.sold_out) || 'Sold out';
      }
      return;
    }

    var hasLimit = hasInventoryLimit(variant.id);
    if (!hasLimit) return; // no inventory limit, nothing to do

    var variantId = variant.id;
    var invLimit = getInvLimit(variant.id);
    var cartQty = window.TDCCartGuard
      ? window.TDCCartGuard.getEffectiveCartQty(variantId)
      : getCartQtyForVariant(variantId);

    var plusBtnEl = document.getElementById('qty-plus');
    var addBtnEl = document.getElementById('add-btn');
    var stickyErrEl = document.getElementById('sticky-inv-error');

    if (cartQty >= invLimit) {
      // Cart is full for this variant — disable +, disable ATC, disable sticky, and show error
      if (plusBtnEl) plusBtnEl.disabled = true;
      var title = variant.title && variant.title !== 'Default Title'
        ? variant.title
        : (productJson && productJson.title ? productJson.title : 'this item');
      showInvError(invLimit, title);

      if (addBtnEl) {
        addBtnEl.disabled = true;
        addBtnEl.classList.add('atc-limit');
        var btnText = document.getElementById('add-btn-text');
        if (btnText) btnText.textContent = 'In bag';
        else addBtnEl.textContent = 'In bag';
      }

      if (stickyAdd) {
        stickyAdd.disabled = true;
        stickyAdd.classList.add('atc-limit');
        stickyAdd.textContent = 'In bag';
      }
      if (stickyErrEl) {
        var stickyMsg = invLimit <= 1
          ? 'Only 1 available — already in your bag'
          : 'Quantity limit reached — only ' + invLimit + ' available';
        stickyErrEl.textContent = stickyMsg;
        stickyErrEl.hidden = false;
      }

      // Also cap the displayed qty to what's allowed (min 1)
      var allowedQty = Math.max(1, invLimit - cartQty);
      setQty(allowedQty);
    } else {
      // Cart has room — re-enable Add to Bag and Sticky Buy if they were at limit
      if (addBtnEl && addBtnEl.classList.contains('atc-limit')) {
        addBtnEl.disabled = false;
        addBtnEl.classList.remove('atc-limit');
        var currentDisplayedQty = parseInt((document.getElementById('quantity') || {}).value, 10) || 1;
        var totalPrice = money(variant.price * currentDisplayedQty);
        var addLabel = (window.theme && window.theme.translations && window.theme.translations.add_to_bag) || 'Add to bag';
        var btnText = document.getElementById('add-btn-text');
        if (btnText) {
          btnText.innerHTML = addLabel + ' · <span id="add-total">' + totalPrice + '</span>';
        } else {
          addBtnEl.innerHTML = addLabel + ' · <span id="add-total">' + totalPrice + '</span>';
        }
      }
      if (stickyAdd && stickyAdd.classList.contains('atc-limit')) {
        stickyAdd.disabled = false;
        stickyAdd.classList.remove('atc-limit');
        stickyAdd.textContent = 'Add to bag';
      }
      if (stickyErrEl) stickyErrEl.hidden = true;

      // Ensure + reflects correct state based on whether currentDisplayedQty + cartQty >= invLimit
      var currentDisplayedQty = parseInt((document.getElementById('quantity') || {}).value, 10) || 1;
      var atLimit = (currentDisplayedQty + cartQty) >= invLimit;
      if (plusBtnEl) plusBtnEl.disabled = atLimit;
      if (!atLimit) clearInvError();
    }
  }

  // Initial sync on script load
  var initialQty = parseInt((document.getElementById('quantity') || {}).value, 10) || 1;
  setQty(initialQty);
  refreshPdpButtonsFromCart();

  // Run once immediately if cart is already available
  if (window.TDCCart && window.TDCCart.currentCart) {
    refreshPdpButtonsFromCart();
  }

  // Also run after cart loads (hooks TDCCart.fetch which is called in custom.js)
  var _origFetch = window.TDCCart && window.TDCCart.fetch;
  if (_origFetch) {
    window.TDCCart.fetch = function () {
      return _origFetch.apply(this, arguments).then(function (cart) {
        refreshPdpButtonsFromCart();
        return cart;
      });
    };
  }

  // Also listen for any cart changes (add, remove, quantity update)
  document.addEventListener('cart:updated', refreshPdpButtonsFromCart);
})();

